import { Gondor } from "../Gondor";

const ACTIONS = {
  APPLICATION: "/application/",
};

export function update(body: any, applicationId?: string) {
  return Gondor.http.patch(ACTIONS.APPLICATION + applicationId, body);
}
